import React from 'react';
import { ArrowUpRight, ShoppingBag } from 'lucide-react';
import { useCart } from '../context/CartContext';
import toast from 'react-hot-toast';

export default function ProductCard({ product, onOpen }) {
  const { addToCart } = useCart();
  const image = product.images?.[0] || product.image;
  const purchasable = product.available !== false && Number.isFinite(Number(product.price)) && Number(product.price) > 0;
  function add(e) {
    e.stopPropagation();
    addToCart(product, 1);
    toast.success(`${product.name} er lagt i handlekurven`);
  }
  return <article className="shop-card" onClick={onOpen}>
    <button className="shop-card-view" onClick={onOpen} aria-label={`Se detaljer om ${product.name}`}>
      <div className="shop-card-image">{image && <img src={image} alt={product.name} loading="lazy"/>}<span className="shop-card-arrow"><ArrowUpRight size={19}/></span>{product.imageNote && <span className="shop-card-photo-note">Illustrasjonsfoto</span>}</div>
    </button>
    <div className="shop-card-body">
      <div className="shop-card-meta"><span>{product.category || 'BMW-tilbehør'}</span><span>{product.subcategory || 'Tilbehør'}</span></div>
      <button className="shop-card-title" onClick={onOpen}>{product.name}</button>
      <p>{product.description?.split('\n')[0]}</p><small className="card-fitment">{product.available === false ? 'Ta kontakt for pris og tilgjengelighet' : 'Mål felgens senterkopp før kjøp'}</small>
      <div className="shop-card-bottom"><strong>{purchasable ? `${Number(product.price).toLocaleString('no-NO')} kr` : 'Pris på forespørsel'}</strong>{purchasable ? <button onClick={add} aria-label={`Legg ${product.name} i handlekurven`}><ShoppingBag size={17}/> Legg i kurv</button> : <button onClick={e => { e.stopPropagation(); onOpen(); }}>Se detaljer</button>}</div>
    </div>
  </article>;
}
